export default "__VITE_ASSET__ClS_Z8yQ__"